<!--
reset_html/frontend/src/js/contents/components/common/common/Checkbox.vueのコンポーネントを複製して作成しました。
Checkbox.vueは状態保持していないため、1ページで複数呼び出しすると正常に動作しません。
Checkbox.vueの編集は既存ページの多くに影響を与える可能性があるため、新規コンポーネントして作成。
 -->
<template>
  <div>
    <input
      :id="checkboxId"
      v-model="checkBoxModel"
      :name="checkboxName"
      type="checkbox"
      class="checkbox"
      :disabled="disabled"
      autocomplete="off"
    />
    <label class="checkLabel" :for="checkboxId" :class="{ isFormShiryo: isFormShiryo }">
      <!-- 以下のslot内では、pタグが使えません。
          なので、spanタグを使い、複数行の場合はbrタグを使いましょう。 -->
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CheckboxMultiple',
  model: {
    prop: 'checkboxFlg',
    event: 'change-checkbox-state',
  },
  props: {
    checkboxId: {
      type: String,
      required: true,
    },
    checkboxName: {
      type: String,
      required: false,
      default: undefined,
    },
    checkboxValue: {
      type: String,
      required: false,
      default: undefined,
    },
    checkboxFlg: {
      type: Boolean,
      required: false,
      default: true,
    },
    isFormShiryo: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isCheckedState: this.checkboxFlg,
    };
  },
  computed: {
    checkBoxModel: {
      get() {
        return this.isCheckedState;
      },
      set(value) {
        this.$emit('change-checkbox-state', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

.checkbox {
  display: none;

  & + .checkLabel {
    display: flex;
    position: relative;
    cursor: pointer;

    &::before {
      content: '';
      border: $border-sapuri-white-light;
      border-radius: 4px;
      position: absolute;
      width: 18px;
      height: 18px;
    }

    &.isFormShiryo {
      left: 12px;

      &::before {
        background-color: #fff;
      }
    }
  }

  &:checked + .checkLabel {
    display: flex;
    position: relative;

    &::before {
      background-color: $color-action-primary;
      border: solid 1px $color-action-primary;
    }

    &::after {
      border-bottom: solid 2px #fff;
      border-right: solid 2px #fff;
      content: '';
      height: 8px;
      width: 3px;
      position: absolute;
      left: 8px;
      top: 4px;
      transform: rotate(45deg);
    }
  }

  &:disabled + .checkLabel {
    display: flex;
    cursor: default;

    &::before {
      background-color: #fff;
      border: solid 1px #d3d4d4;
    }
  }

  &:disabled:checked + .checkLabel {
    display: flex;
    cursor: default;

    &::before {
      background-color: #d3d4d4;
    }

    &::after {
      border-bottom: solid 2px #fff;
      border-right: solid 2px #fff;
      content: '';
      height: 8px;
      width: 3px;
      position: absolute;
      left: 8px;
      top: 4px;
      transform: rotate(45deg);
    }
  }
}
</style>
